export function analyticsHandler(metric, data) {
  return generatePointToPointPercentageArray(
    data.sle.samples.degraded,
    data.sle.samples.total
  )
}

function generatePointToPointPercentageArray(degraded, total) {
  let percentageArray = []
  for (let i = 0; i < total.length; i++) {
    let d = degraded[i]
    let t = total[i]
    if (d === null || t === null) {
      percentageArray.push(null)
      continue
    }
    const res = (1 - degraded[i] / total[i]) * 100
    percentageArray.push(res)
  }
  return percentageArray
}

function prettyMissingClassifier(classifier) {
  let prettyClassifier = classifier.replaceAll('-', ' ')
  let words = prettyClassifier.split(' ')

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1)
  }
  let finalWords = words.join(' ')
  return finalWords
}

export function servicePercentage(degraded, total) {
  let sumDegraded = 0
  let sumTotal = 0

  degraded.forEach((element) => {
    sumDegraded += element
  })

  total.forEach((element) => {
    sumTotal += element
  })
  let result = (1 - sumDegraded / sumTotal) * 100
  if (isNaN(result)) {
    return 0
  }
  return result
}

export function classifierPercentage(degraded, totalDegraded) {
  let sumDegraded = 0
  let sumTotal = totalDegraded

  degraded.forEach((element) => {
    sumDegraded += element
  })

  let result = (sumDegraded / sumTotal) * 100
  if (isNaN(result)) {
    return 0
  }
  return Math.round(result)
}

export function getFormattedClassifierName(classifier) {
  switch (classifier) {
    case 'asymmetry-uplink':
      return 'Asymmetry Uplink'

    case 'asymmetry-downlink':
      return 'Asymmetry Downlink'

    case 'weak-signal':
      return 'Weak Signal'

    case 'wifi-interference':
      return 'WiFi Interference'

    case 'client-usage':
      return 'Client Usage'

    case 'non-wifi-interference':
      return 'Non-WiFi Interference'

    case 'client-count':
      return 'Client Count'

    case 'ethernet-speed-mismatch':
      return 'Ethernet Speed Mismatch'

    case 'ethernet-ethernet-errors':
      return 'Ethernet Error'

    case 'ap-disconnected-ap-reboot':
      return 'AP Reboot'

    case 'ap-disconnected-site-down':
      return 'Site Down'

    case 'ap-disconnected-ap-unreachable':
      return 'AP Unreachable'

    case 'low-power':
      return 'Low Power'

    case 'association':
      return 'Association'

    case 'dhcp-unresponsive' || 'dhcp-renew-unresponsive':
      return 'DHCP Unresponsive'

    case 'dhcp-incomplete':
      return 'DHCP Incomplete'

    case 'dhcp-nack':
      return 'DHCP Nack'

    case 'authorization':
      return 'Authorization'

    case 'capacity-wifi-interference':
      return 'Capacity WiFi Interference'

    case 'device-capability':
      return 'Device Capability'

    case 'capacity-excessive-client-load':
      return 'Excessive Client Load'

    case 'capacity-non-wifi-interference':
      return 'Non-WiFi Interference'

    case 'capacity-high-bandwidth-utilization':
      return 'High Bandwidth Utilization'

    case 'network-issues':
      return 'Network Issues'

    case 'coverage':
      return 'Coverage'

    case 'dns':
      return 'DNS'

    case 'arp':
      return 'ARP'

    case 'dhcp-discover-unresponsive':
      return 'Discover Unresponsive'

    case 'dhcp-renew-unresponsive':
      return 'Renew Unresponsive'

    case 'ap-disconnected-switch-down':
      return 'Switch Down'

    case 'dhcp-stuck':
      return 'DHCP Stuck'

    case 'signal-quality-interband-roam':
      return 'Signal Quality'

    case 'latency-slow-11r-roam':
      return 'Latency 11r'

    case 'latency-slow-standard-roam':
      return 'Latency'

    case 'stability-failed-to-fast-roam':
      return 'Stability Fast Roam'

    case 'latency-slow-okc-roam':
      return 'Latency Slow Roam'

    case 'signal-quality-suboptimal-roam':
      return 'Signal Quality Roam'

    case 'signal-quality-sticky-client':
      return 'Sticky Client'

    default:
      return prettyMissingClassifier(classifier)
  }

  //let formattedString = classifier.replace(/-/g, ' ')
  //return formattedString
}
